export default [
  {
    title: "Dashboard",
    route: "home",
    icon: "ActivityIcon",
    resource: "dashboard",
    action: "consulter-dashboard",
  },
  {
    title: "Véhicules",

    icon: "HomeIcon",
    children: [
      {
        title: "Catalogues",
        route: "catalogue",
        icon: "ShoppingCartIcon",
        resource: "vehicule",
        action: "consulter-catalogue",
      },
      {
        title: "Reprise",
        route: "reprise",
        icon: "RefreshCwIcon",
        resource: "vehicule",
        action: "consulter-reprise",
      },
      {
        title: "Gestion de stock",
        route: "gestion-de-stock",
        icon: "HardDriveIcon",
        resource: "vehicule",
        action: "consulter-gestion-stock",
      },
      {
        title: "Vendu",
        route: "vendu",
        icon: "StarIcon",
        resource: "vendu",
        action: "consulter-vendu",
      },
    ],
  },
  {
    title: "Marchand",
    icon: "UserIcon",
    children: [
      {
        title: "Liste offre Marchand",
        route: "marchand",
        resource: "marchand",
        action: "consulter-marchand",
      },
      {
        title: "Vendu B2B",
        route: "vendu-b2b",
        resource: "marchand",
        action: "consulter-marchand",
      },
    ],
  },
  {
    title: "Liste des Offres",
    icon: "LayersIcon",
    children: [
      {
        title: "Toutes les offres",
        route: "list-des-offres",
        resource: "list-bdc",
        action: "consulter-liste-offres",
      },
      {
        title: "Offres annulées",
        route: "list-des-offres-annulees",
        resource: "list-bdc",
        action: "consulter-liste-offres",
      },
    ],
  },
  {
    title: "Clients",
    route: "clients",
    icon: "UsersIcon",
    resource: "client",
    action: "consulter-client",
  },
  {
    title: "Livraisons",
    route: "livraisons",
    icon: "TruckIcon",
    resource: "livraison",
    action: "consulter-livraison",
  },
  {
    title: "Leads",
    route: "leads",
    icon: "UserCheckIcon",
    resource: "leads",
    action: "export-leads",
  },

  {
    title: "Paramètres",
    icon: "SettingsIcon",
    children: [
      {
        title: "Concessions",
        route: "concessions",
        icon: "HomeIcon",
        resource: "concession",
        action: "manage-concession",
      },

      {
        title: "Sites",
        route: "sites",
        icon: "HomeIcon",
        resource: "site",
        action: "manage-site",
      },
      {
        title: "Villes Avito",
        route: "avito-cities",
        icon: "MapPinIcon",
        resource: "site",
        action: "manage-site",
      },
      {
        title: "Zones Avito",
        route: "avito-areas",
        icon: "MapIcon",
        resource: "site",
        action: "manage-site",
      },
      {
        title: "Utilisateurs",
        route: "utilisateurs",
        icon: "HomeIcon",
        resource: "utilisateur",
        action: "manage-utilisateur",
      },
      {
        title: "Activités utilisateur",
        route: "user-activities-log",
        icon: "HomeIcon",
        resource: "utilisateur",
        action: "manage-utilisateur",
      },
      {
        title: "Journal d'actions",
        route: "journal-actions",
        icon: "ListIcon",
        resource: "parametres",
        action: "consulter-journal-actions",
      },
      {
        title: "Roles",
        route: "roles",
        icon: "HomeIcon",
        resource: "role",
        action: "gestion-role",
      },
      {
        title: "Groupes",
        route: "groupes",
        icon: "HomeIcon",
        resource: "groupes",
        action: "manage-groupe",
      },
      {
        title: "Certificat Spoticar",
        route: "certificat-spoticar",
        icon: "ShieldIcon",
        resource: "parametres",
        action: "gerer-certificat-spoticar",
      },
      {
        title: "Supervision",
        route: "supervision",
        icon: "ServerIcon",
        resource: "supervision",
        action: "consulter-supervision",
      },
    ],
  },
];
